import { render, staticRenderFns } from "./PersonOverlaps.vue?vue&type=template&id=29181ad1&"
import script from "./PersonOverlaps.vue?vue&type=script&lang=js&"
export * from "./PersonOverlaps.vue?vue&type=script&lang=js&"
import style0 from "./PersonOverlaps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports